import {
  IonButton,
  IonButtons,
  IonCol,
  IonContent,
  IonGrid,
  IonIcon,
  IonModal,
  IonRow,
  IonText,
  IonTitle,
  IonToolbar,
} from '@ionic/react';
import { wifi } from 'ionicons/icons';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import './gate-failed.css';

export interface GateFailedProps {
  title: string;
  description: string;
  isOpen: boolean;
  rightButtons?: ReactElement;
  retry: () => Promise<void>;
}

const GateFailed = (props: GateFailedProps) => {
  const { isOpen, retry, title, description, rightButtons } = props;

  const { i18n } = useTranslation();

  return (
    <IonModal
      isOpen={isOpen}
      backdropDismiss={false}
      initialBreakpoint={0.4}
      className="gate-failed"
    >
      <IonToolbar>
        {rightButtons && <IonButtons slot="end">{rightButtons}</IonButtons>}
        <IonTitle>{title}</IonTitle>
      </IonToolbar>
      <IonContent scrollY={false}>
        <IonGrid className="ion-padding ion-text-center">
          <IonRow>
            <IonCol>
              <IonText>{description}</IonText>
            </IonCol>
          </IonRow>
          <IonRow>
            <IonCol>
              <IonIcon
                icon={wifi}
                style={{
                  width: '60px',
                  height: '60px',
                }}
              />
            </IonCol>
          </IonRow>
          <IonRow>
            <IonCol>
              <IonButton
                style={{ minWidth: '120px' }}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  retry();
                }}
              >
                {i18n.t('common:retry')}
              </IonButton>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonModal>
  );
};

export { GateFailed };
